module.exports = __webpack_public_path__ + "img/乌药.5fe51575.jpg";